import InputCheckbox from "../inputs/InputCheckbox";

export default function FindClassesBar(props) {
  return (
    <div className="sm:hidden flex items-center h-11 px-4 border-b border-borderGray bg-bgGray">
      <div className="flex flex-1">
        <div>
          <InputCheckbox
            onChange={props.onSelectAll}
            checked={props.selectAll}
            className="items-center"
            small
          >
            <span className="text-sm font-bold uppercase">Select All</span>
          </InputCheckbox>
        </div>
      </div>
    </div>
  );
}
